import configJson from "../../Config.json";
import CryptoJS from "crypto-js";
const SECRET = "MAKV2SPBNI99212";//configJson.APIExpirySalt;
export function encryptTimestamp() {
    const timestamp = new Date().toISOString();
    // 1️⃣ Derive a 32-byte key
    const key = CryptoJS.SHA256(SECRET);
    // 2️⃣ Generate random 16-byte IV
    const iv = CryptoJS.lib.WordArray.random(16);
    // 3️⃣ Encrypt
    const encrypted = CryptoJS.AES.encrypt(timestamp, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    // 4️⃣ Combine IV + ciphertext → Base64
    const combined = iv.concat(encrypted.ciphertext);
    return CryptoJS.enc.Base64.stringify(combined);
}